import type { IconData } from '@stacksjs/iconify-core'

export const handFour: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M26.66 7.62h1.53v12.19h-1.53Zm-1.52 12.19h1.52v4.58h-1.52Zm-1.52 7.62H9.9v-1.52H8.38v1.52H6.85V32h19.81v-4.57h-1.52v-3.04h-1.52Zm0 3.05h-3.05v-1.52h3.05Zm-1.53-15.24h1.53V7.62h3.04V6.1h-3.04V4.58h-1.53zm-4.57 0h1.53V4.58h3.04V3.05h-3.04V1.53h-1.53zM16 16.77h1.52v3.04H16ZM14.47 0h3.05v1.53h-3.05Zm0 15.24H16v1.53h-1.53Zm-3.04 4.57H16v1.53h-4.57Zm1.52-6.09h-1.52v1.52h3.04V1.53H9.9v1.52h3.05zM9.9 18.29h1.53v1.52H9.9Z\"/><path fill=\"currentColor\" d=\"M11.43 13.72v-1.53H9.9V3.05H8.38v9.14H6.85v1.53zM6.85 24.39h1.53v1.52H6.85Zm-1.52-3.05h1.52v3.05H5.33Zm0-7.62h1.52v1.52H5.33Zm-1.52 1.52h1.52v6.1H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handFour
